export default [
    {
        path: '/minimum-margin',
        props: true,
        component: () => import('@/views/MinimumMargin'),
    },
];